/**
 * New-game intro gate.
 *
 * Adventures can declare an `introKnot` in their manifest — an Ink knot of
 * world-establishing flavor text played exactly once when a brand-new game
 * begins. The UI's new-game paths call `markPendingIntro()` right before
 * sending BEGIN_NEW_GAME; `loadAndBuildMap` consumes the flag after the
 * entry map's story finishes loading and starts the knot.
 *
 * Loading a save must never replay the intro, so `PersistenceManager.load`
 * clears the flag — covering the edge where a player marks a new game,
 * backs out of the character creator, and loads a save instead.
 */

let pending = false;

/** Arm the gate. Call from every new-game start path, never from loads. */
export function markPendingIntro(): void {
  pending = true;
}

/** Disarm without firing (save restores, test teardown). */
export function clearPendingIntro(): void {
  pending = false;
}

/** Read-and-clear. True exactly once after a `markPendingIntro()`. */
export function consumePendingIntro(): boolean {
  const was = pending;
  pending = false;
  return was;
}
